import { render, staticRenderFns } from "./AiMyprDialogHeader.vue?vue&type=template&id=6de9c2fe"
import script from "./AiMyprDialogHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiMyprDialogHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports